// Reviews from Orbit. Fills every [data-lp-reviews] element, a section of
// sections/lp-review-list.liquid or the line of
// blocks/lp-review-summary.liquid, from the Orbit feed URL it carries:
//
//   { list, summary: { count, averageRating },
//     reviews: [{ id, rating, title, body, authorName, instagramHandle,
//                 reviewedAt, tags, media: [image or video] }] }
//
// The feed is customer text from another origin, checked once by
// parseFeed(): it reaches the page only as text and attribute values, and
// only http(s) URLs and plain Instagram handles become sources or links. An
// element whose feed fails, takes too long or has no reviews removes itself,
// so the page shows no empty box.
//
// A section with data-lp-reviews-pick="random" fetched its whole list and
// shows a random draw of data-lp-reviews-max of its reviews, each from a
// different reviewer while the list has enough names, a new draw on every
// visit. The average and count still cover every review the
// feed sent.
//
// LAYOUTS draws the reviews in the theme's own markup, which the section
// keeps in templates rendered by the snippets the hand-filled sections use:
// lp-reviews' lp-rcard with lp-before-after's labelled pair, the card
// carousel, and lp-stories' strip, cards and viewer. Each review gets a copy
// of a template with its text, sources, links and labels filled in and the
// parts it lacks removed, so lp-sleep.css and the page's skin dress it as
// they dress the hand-filled sections. lp-carousel.js and lp-stories.js wire
// that markup when it announces itself with lp:content.
//
// The helpers it shares with the landing pages' review sections (text and
// URL checks, stars, copies, the loader and the fold) come from
// assets/lp-review-kit.js, which the section and the summary block load
// first.
//
// Runs once per element even if the file is included twice.
(function () {
  var kit = window.lpReviewKit;
  var HANDLE = /^[A-Za-z0-9._]{1,30}$/;
  var text = kit.text;
  var source = kit.source;
  var set = kit.set;
  var fillOrRemove = kit.fillOrRemove;
  var replaceWithCopies = kit.copies;
  var rate = kit.rate;
  var announce = kit.announce;

  function dimension(value) {
    return typeof value === 'number' && value > 0 ? value : null;
  }
  function medium(item) {
    if (!item || typeof item !== 'object') return null;
    var labels = Array.isArray(item.labels) ? item.labels.map(function (label) { return String(label).toLowerCase(); }) : [];
    var shape = { labels: labels, width: dimension(item.width), height: dimension(item.height) };
    if (item.kind === 'image') {
      var thumb = source(item.thumbUrl);
      var full = source(item.fullUrl);
      return thumb && full ? Object.assign(shape, { kind: 'image', thumb: thumb, full: full }) : null;
    }
    if (item.kind === 'video') {
      var src = source(item.videoUrl);
      var poster = source(item.posterUrl);
      return src && poster ? Object.assign(shape, { kind: 'video', src: src, poster: poster }) : null;
    }
    return null;
  }
  function review(item) {
    if (!item || typeof item !== 'object') return null;
    var body = text(item.body);
    var name = text(item.authorName);
    var rating = item.rating;
    if (!body || !name || [1, 2, 3, 4, 5].indexOf(rating) === -1) return null;
    var handle = (text(item.instagramHandle) || '').replace(/^@/, '');
    return {
      rating: rating,
      title: text(item.title),
      body: body,
      name: name,
      handle: HANDLE.test(handle) ? handle : null,
      media: Array.isArray(item.media) ? item.media.map(medium).filter(Boolean) : [],
    };
  }
  // null when the response is not a feed. count covers the whole list,
  // beyond the reviews the limit let through.
  function parseFeed(json) {
    if (!json || typeof json !== 'object' || !Array.isArray(json.reviews)) return null;
    var reviews = json.reviews.map(review).filter(Boolean);
    var summary = json.summary || {};
    var average = summary.averageRating;
    return {
      count: typeof summary.count === 'number' && summary.count >= reviews.length ? summary.count : reviews.length,
      average: typeof average === 'number' && average >= 1 && average <= 5 ? average : null,
      reviews: reviews,
    };
  }

  function hasLabel(label) {
    return function (item) { return item.labels.indexOf(label) !== -1; };
  }
  // What a card shows besides its words: the pair when one photo is
  // labelled before and another after, the first video, and every other
  // photo as a thumbnail. gallery is every photo in feed order, what the
  // lightbox pages through.
  function mediaOf(item) {
    var gallery = item.media.filter(function (m) { return m.kind === 'image'; });
    var before = gallery.filter(hasLabel('before'))[0];
    var after = gallery.filter(function (m) { return m !== before && hasLabel('after')(m); })[0];
    var pair = before && after ? { before: before, after: after } : null;
    return {
      pair: pair,
      video: item.media.filter(function (m) { return m.kind === 'video'; })[0] || null,
      photos: gallery.filter(function (m) { return !pair || (m !== pair.before && m !== pair.after); }),
      gallery: gallery,
    };
  }

  function partCloner(root) {
    return function (name) {
      return root.querySelector('template[data-lp-reviews-part="' + name + '"]').content.firstElementChild.cloneNode(true);
    };
  }
  function profile(link, item) {
    if (!item.handle) return link.remove();
    set(link, { href: 'https://www.instagram.com/' + item.handle + '/' });
    link.textContent = '@' + item.handle;
  }

  function opens(button, image, item, media, view) {
    button.addEventListener('click', function () { view.open(media.gallery, media.gallery.indexOf(image), item, button); });
  }
  function pair(node, item, media, view) {
    if (!media.pair) return node.remove();
    var images = [media.pair.before, media.pair.after];
    Array.prototype.forEach.call(node.querySelectorAll('button'), function (shot, i) {
      var image = images[i];
      set(shot, { 'aria-label': item.name + ', ' + (i ? 'after' : 'before') + ', open photo' });
      set(shot.querySelector('img'), { src: image.thumb, srcset: image.thumb + ' 320w, ' + image.full + ' 1600w' });
      opens(shot, image, item, media, view);
    });
  }
  function thumbnails(node, item, media, view) {
    if (!media.photos.length) return node.remove();
    replaceWithCopies(node.querySelector('button'), media.photos, function (thumb, image, i) {
      set(thumb, { 'aria-label': 'Open photo ' + (i + 1) + ' from ' + item.name });
      set(thumb.querySelector('img'), { src: image.thumb });
      opens(thumb, image, item, media, view);
    });
  }
  // The video loads nothing until it is tapped: a poster and a play button
  // stand in, and the tap swaps in the player and starts it.
  function clip(button, item, video, view) {
    if (!video) return button.remove();
    var ratio = video.width && video.height ? Math.min(16 / 9, Math.max(4 / 5, video.width / video.height)) : 4 / 5;
    var style = 'aspect-ratio: ' + ratio.toFixed(4);
    var label = item.name + "'s video";
    set(button, { style: style, 'aria-label': 'Play ' + label });
    set(button.querySelector('img'), { src: video.poster });
    button.addEventListener('click', function () {
      var player = set(view.part('player'), { style: style, src: video.src, poster: video.poster, 'aria-label': label });
      button.replaceWith(player);
      player.focus();
      player.play().catch(function () {});
    });
  }
  function card(item, view) {
    var node = view.part('card');
    var media = mediaOf(item);
    rate(node.querySelector('.lp-stars'), item.rating);
    fillOrRemove(node.querySelector('.lp-rcard__headline'), item.title);
    pair(node.querySelector('.lp-bacard__pair'), item, media, view);
    clip(node.querySelector('.lp-rcard__video'), item, media.video, view);
    thumbnails(node.querySelector('.lp-rcard__photos'), item, media, view);
    fillOrRemove(node.querySelector('.lp-rcard__quote'), item.body);
    fillOrRemove(node.querySelector('.lp-rcard__who'), item.name);
    profile(node.querySelector('.lp-rcard__handle'), item);
    return node;
  }

  function carousel(cards, view) {
    var node = view.part('carousel');
    if (cards.length < 2) node.classList.add('lp-carousel--single');
    replaceWithCopies(node.querySelector('.lp-carousel__slide'), cards, function (slide, card) { slide.append(card); });
    return node;
  }

  // A story without a photo or video is its words on a card. Its viewer
  // slide stays up long enough to read: about 200 words a minute, 5 to 20
  // seconds (lp-stories.js reads data-lp-stories-ms).
  function readingMs(item) {
    var words = (item.title ? item.title + ' ' : '').concat(item.body).split(/\s+/).length;
    return Math.min(20000, Math.max(5000, words * 300));
  }
  function story(item, visual, view) {
    var node = view.part(visual ? 'story' : 'story-words');
    set(node, { 'aria-label': item.name + (item.handle ? ', @' + item.handle : '') });
    if (visual) {
      var photo = node.querySelector('img');
      set(photo, { src: visual.kind === 'video' ? visual.poster : visual.thumb });
      if (visual.kind === 'image') {
        set(photo, { srcset: visual.thumb + ' 320w, ' + visual.full + ' 1600w' });
        node.querySelector('.lp-story__play').remove();
      }
    } else {
      rate(node.querySelector('.lp-stars'), item.rating);
      fillOrRemove(node.querySelector('.lp-story__quote'), item.title || item.body);
    }
    fillOrRemove(node.querySelector('.lp-story__name'), item.name);
    fillOrRemove(node.querySelector('.lp-story__handle'), item.handle && '@' + item.handle);
    fillOrRemove(node.querySelector('.lp-story__caption'), visual && item.title);
    return node;
  }
  function slide(item, visual, view) {
    var node = view.part(visual ? 'slide' : 'slide-words');
    if (!visual) {
      var words = node.querySelector('.lp-stories__words');
      if (item.body.length > 320) words.classList.add('lp-stories__words--long');
      rate(words.querySelector('.lp-stars'), item.rating);
      fillOrRemove(words.querySelector('b'), item.title);
      fillOrRemove(words.querySelector('p'), item.body);
    } else if (visual.kind === 'video') {
      node.querySelector('img').remove();
      set(node.querySelector('video'), { 'data-lp-src': visual.src, poster: visual.poster, 'aria-label': item.name + "'s video" });
    } else {
      node.querySelector('video').remove();
      set(node.querySelector('img'), { src: visual.full, alt: item.name + "'s photo" });
    }
    if (!visual || visual.kind !== 'video') set(node, { 'data-lp-stories-ms': readingMs(item) });
    fillOrRemove(node.querySelector('.lp-stories__name'), item.name);
    profile(node.querySelector('.lp-stories__handle'), item);
    if (visual) fillOrRemove(node.querySelector('.lp-stories__caption'), (item.title ? item.title + '. ' : '') + item.body);
    return node;
  }
  function stories(reviews, view) {
    var node = view.part('stories');
    var strip = node.querySelector('[data-lp-stories-strip]');
    var stage = node.querySelector('[data-lp-stories-stage]');
    var visuals = reviews.map(function (item) {
      var media = mediaOf(item);
      return media.video || (media.pair && media.pair.after) || media.gallery[0] || null;
    });
    strip.append.apply(strip, reviews.map(function (item, i) { return story(item, visuals[i], view); }));
    stage.prepend.apply(stage, reviews.map(function (item, i) { return slide(item, visuals[i], view); }));
    replaceWithCopies(node.querySelector('.lp-stories__bar'), reviews, function () {});
    return node;
  }

  var LAYOUTS = {
    cards: function (reviews, view) {
      return reviews.map(function (item) { return card(item, view); });
    },
    carousel: function (reviews, view) {
      return [carousel(reviews.map(function (item) { return card(item, view); }), view)];
    },
    stories: function (reviews, view) {
      return [stories(reviews, view)];
    },
  };

  // The photo viewer: lp-stories' full-screen dialog holding the shop
  // carousel, opened at the tapped photo of a review's gallery.
  function lightbox(root, part) {
    return function open(gallery, index, item, opener) {
      var dialog = part('lightbox');
      var track = dialog.querySelector('.lp-carousel__track');
      var close = dialog.querySelector('.lp-rlightbox__close');
      if (gallery.length < 2) dialog.querySelector('.lp-carousel').classList.add('lp-carousel--single');
      set(dialog, { 'aria-label': item.name + "'s photos" });
      set(track, { 'aria-label': item.name + "'s photos" });
      replaceWithCopies(track.querySelector('.lp-carousel__slide'), gallery, function (slide, image, i) {
        set(slide.querySelector('img'), { src: image.full, alt: item.name + ', photo ' + (i + 1) + ' of ' + gallery.length });
      });
      close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        dialog.remove();
        opener.focus({ preventScroll: true });
      });
      root.appendChild(dialog);
      dialog.showModal();
      announce(dialog);
      track.scrollTo({ left: index * track.clientWidth, behavior: 'instant' });
    };
  }

  // Fisher-Yates over a copy.
  function shuffle(reviews) {
    var pool = reviews.slice();
    for (var i = 0; i < pool.length - 1; i++) {
      var j = i + Math.floor(Math.random() * (pool.length - i));
      var drawn = pool[j];
      pool[j] = pool[i];
      pool[i] = drawn;
    }
    return pool;
  }
  // `count` reviews drawn at random, each from a different reviewer while the
  // list has enough names; a name repeats only once every name has had a turn.
  function sample(reviews, count) {
    var pool = shuffle(reviews);
    var seen = {};
    var picked = [];
    var repeats = [];
    pool.forEach(function (item) {
      var name = item.name.trim().toLowerCase();
      if (seen[name]) return repeats.push(item);
      seen[name] = true;
      picked.push(item);
    });
    return picked.concat(repeats).slice(0, Math.min(count, pool.length));
  }

  function fillSummary(scope, feed) {
    var score = scope.matches('[data-lp-reviews-score]') ? scope : scope.querySelector('[data-lp-reviews-score]');
    if (!score) return;
    if (feed.average === null) return score.remove();
    var average = feed.average.toFixed(1);
    score.querySelector('b').textContent = average;
    var meter = score.querySelector('.lp-stars');
    meter.classList.add('lp-stars--meter');
    meter.style.setProperty('--lp-stars-fill', (feed.average / 5 * 100).toFixed(1) + '%');
    meter.setAttribute('role', 'img');
    meter.setAttribute('aria-label', 'Rated ' + average + ' out of 5');
    meter.removeAttribute('aria-hidden');
    score.querySelector('.lp-rlist__count').textContent = kit.count(feed.count);
  }

  function foldLongQuotes(root) {
    kit.fold(Array.prototype.map.call(root.querySelectorAll('.lp-rcard--orbit'), function (node) {
      var fold = { words: node.querySelector('.lp-rcard__quote'), more: node.querySelector('.lp-rcard__more') };
      fold.more.textContent = 'Read more';
      kit.toggles(fold, 'Read more', 'Show less');
      return fold;
    }));
  }

  function render(root, feed) {
    var layout = root.getAttribute('data-lp-reviews-layout');
    // The list's first reviews in Orbit's order that the section leaves out,
    // before the pick; the summary still counts them.
    var shown = feed ? feed.reviews.slice(parseInt(root.getAttribute('data-lp-reviews-skip'), 10) || 0) : [];
    var empty = !feed || (layout === 'summary' ? feed.count === 0 || feed.average === null : shown.length === 0);
    if (empty) return root.remove();
    fillSummary(root, feed);
    if (layout !== 'summary') {
      var reviews = root.getAttribute('data-lp-reviews-pick') === 'random'
        ? sample(shown, parseInt(root.getAttribute('data-lp-reviews-max'), 10) || shown.length)
        : shown;
      var part = partCloner(root);
      var view = { part: part, open: lightbox(root, part) };
      var slot = root.querySelector('[data-lp-reviews-slot]');
      slot.replaceWith.apply(slot, LAYOUTS[layout](reviews, view));
      foldLongQuotes(root);
    }
    root.removeAttribute('aria-busy');
    announce(root);
  }

  function watch(root) {
    kit.watch(root, function () {
      var url = root.getAttribute('data-lp-reviews');
      kit.get(url, parseFeed).then(function (feed) { render(root, feed); }).catch(function (error) {
        root.remove();
        console.warn('lp-reviews: ' + url + ': ' + error.message);
      });
    });
  }
  function scan(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-lp-reviews]'), watch);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
